<template lang='pug'>
v-app#page4_2(style='background: #FFFFFF !important;')
	v-container(fluid, grid-list-xl)
		v-content
			v-layout(row, justify-center)
				v-flex(xs11, sm10, md9, lg8, text-xs-center)
					.review(v-if='sent', color='primary', @click.prevent='')
					v-card(flat)
						breadcrumb(back='page4-1')
							| Estás en: Elige tu Crédito Hipotecario / ¡Quiero saber cómo me protege un Crédito Hipotecario!
						v-card-text.text-xs-center.label16tt.withDivider
							| PREGUNTA
						v-card-text.parrafoDestacado18.mx-0.px-0
							| En el video que acabas de ver, presentamos cinco seguros para tu Crédito Hipotecario en caso de eventos inesperados
							| A continuación, determina cuáles de los siguientes casos sí están cubiertos por los seguros del Crédito Hipotecario.
						v-layout.pb-4.ma-0.pt-0(row, justify-center)
							v-flex.py-0.ma-0(xs12)
								v-layout.pa-0.pl-4.ma-1.leftBlueBorder(row, align-center, v-for='reactivo in reactivos', :key='reactivo')
									v-flex.pa-0.ma-0.text-xs-left(xs8, sm10)
										.parrafoDestacadoB {{reactivo.descripcion}}
									v-flex.pa-0.ma-0(xs2, sm1)
										v-btn.toggle.ma-1(:color="testValueTrue(reactivo.respuesta, reactivo.resultado)", @click.prevent='reactivo.respuesta=true;', block, value='true')
											| Sí
									v-flex.pa-0.ma-0.mr-3(xs2, sm1)
										v-btn.toggle.ma-2(:color="testValueFalse(reactivo.respuesta, reactivo.resultado)", @click.prevent='reactivo.respuesta=false;', block, value='false')
											| No

						div(v-if='sent==false ')
							v-btn#attachDialog_10_1.btn(depressed, justify-space-between, type='button ', color='secondary ', :disabled='!completo ', @click=' sendResult() ')
								| Revisar
						div(v-if='sent ')
							v-btn.btn(color='accent ', style='z-index:3', @click.prevent='dialog=true ')
								| Ver Retroalimentación
							v-dialog(v-model='dialog ', persistent, max-width='930px ')
								v-layout(row, justify-center)
									v-flex(text-xs-center)
										v-card
											div(v-if='sent && (resultado==7) ')
												v-layout(v-if='dialog ')
													v-flex(text-xs-center)
														img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
											div(v-if='sent && (resultado!=7) ')
												v-layout(v-if='dialog ')
													v-flex(text-xs-center)
														img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
											v-spacer.my-1.py-4
											div(v-if='sent && (resultado==7) ')
												v-card-text.headline
													| ¡Bien!
												v-card.questionCard(justify-center, flat)
													v-card-text.text-xs-left.px-5
														b ¡Excelente!
													v-card-text.text-xs-left.px-5
														|  Ya sabes que un Crédito Hipotecario te protege y asegura que consigas tu meta
														|  a pesar de algunos imprevistos. ¿Estás listo para elegir el mejor plan para ti?
													v-card-text.text-xs-left.px-5
														|  ¡Sigue adelante!

											div(v-if='sent && (resultado!=7) ')
												v-card-text.headline
													| Hay una mejor respuesta...
												v-card.questionCard(justify-center, flat)
													v-card-text.text-xs-left.px-5
														b Tuviste algunos errores.
														|  Te sugerimos volver a ver el video para que recuerdes las
														b  protecciones de los cinco seguros de tu Crédito Hipotecario.
													v-layout(row)
														v-flex.pt-3.pr-0.pl-5.mr-0.text-xs-left(xs1)
															v-btn.btn_print(fab, dark, color='print ', @click.prevent="showVideo = !showVideo")
																v-icon(dark) fas fa-history
														v-flex(xs11)
															v-card-text.print--text.mx-0.px-5.pt-4.mt-3.parrafoRetro14B.text-xs-left
																b(v-if="showVideo") Ocultar Video
																b(v-else) Volver a ver Video 
													.video-responsive(v-if="showVideo")
														iframe.pa-5(width="420" height="315" src="https://player.vimeo.com/video/287127139" frameborder="0" allowfullscreen)
													v-card-text.text-xs-left.px-5
														| Si deseas continuar, recuerda que un Crédito Hipotecario te protege y
														|  asegura que consigas tu meta a pesar de algunos imprevistos.
														|  ¿Estás listo para elegir el mejor plan para ti?
											v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage('page5-1') ")
												| Siguiente
					l-progress(:value='this.$parent.currentPage')
</template>

<script>
import jsPDF from 'jspdf';
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      msg: 'This is a button',
      reactivos: [{
          descripcion: 'Sufrí un accidente y dejé de trabajar por cuatro meses.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.'
        },
        {
          descripcion: 'Robaron mi casa mientras estaba de viaje.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: '¡No tienes que ser asalariado! Revisa las siguientes opciones con las que cuentas: - Persona física independiente o con actividad empresarial puede comprobar con: - Alta ante SHCP - Declaración anual ISR (último año) - Estados de cuenta de los últimos 6 meses.'
        },
        {
          descripcion: 'Choqué mi auto en un estacionamiento.',
          respuesta: 'none',
          correcta: false,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.'
        },
        {
          descripcion: 'Muero repentinamente sin concluir el pago de mi crédito.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.'
        },
        {
          descripcion: 'Hubo recorte de personal y fui uno de los afectados.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.'
        },
        {
          descripcion: 'Ocurrió un terremoto y mi casa sufrió daños.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none'
        },
        {
          descripcion: 'Debido a una enfermedad, me hospitalizaron quince días.',
          respuesta: 'none',
          correcta: false,
          resultado: 'none'
        }
      ],
      progress: false,
      dialog: false,
      sent: false,
      showVideo: false
    }
  },
  computed: {
    completo: function() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          complete = false;
        }
      })
      return complete;
    },
    resultado: function() {
      var resultado = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == reactivo.correcta) {
          resultado++;
        }
      })
      return resultado;
    }
  },
  methods: {
    downloadPDF() {
      var lineSpace = 7;
      var doc = new jsPDF()
      doc.text('Cumplimiento de requisitos para Crédito Hipotecario', 10, 10)
      doc.setFontSize(12);
      this.reactivos.forEach(function(reactivo, index) {
        if (reactivo.respuesta) {
          doc.setTextColor(0, 255, 0);
          doc.text("[Cumple]", 10, 20 + lineSpace * index);
        } else {
          doc.setTextColor(255, 0, 0);
          doc.text("[No Cumple]", 10, 20 + lineSpace * index);
        }
        doc.setTextColor(0, 0, 0);
        doc.text(reactivo.descripcion, 35, 20 + lineSpace * index);
      })
      doc.save('requisitos.pdf')
    },
    grade: function() {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta == reactivo.respuesta) {
          reactivo.resultado = 1;
          points++;
        } else {
          reactivo.resultado = 0;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      this.$parent.results['page10-1'] = this.reactivos;
      this.$parent.results['page10-1-r'] = this.resultado;
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    testValueTrue(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == true) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'green';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == false) {
        return 'greyNormal'
      }
    },
    testValueFalse(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == false) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'green';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == true) {
        return 'greyNormal'
      }
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>

<style lang="stylus">
.video-responsive
  overflow:hidden
  padding-bottom:56.25%
  position:relative
  height:0

.video-responsive iframe
  left:0
  top:0
  height:100%
  width:100%
  position:absolute

</style>
